import { EIV_STATUS, EIV_STATUS_ALLOWED_TO_REGISTER_EXISTING_EMAIL } from 'global/constants';

export const CIAM_EMAIL_ERROR_TYPES = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  DUPLICATE: 'DUPLICATE',
  ERROR: 'ERROR',
};

export const isPendingCiamRegistration = (statusStrom, statusGas) => {
  if (statusStrom === null && statusGas === EIV_STATUS.PENDING) {
    return true;
  }
  if (statusStrom === EIV_STATUS.PENDING && statusGas === null) {
    return true;
  }
  if (statusStrom === EIV_STATUS.PENDING && statusGas === EIV_STATUS.PENDING) {
    return true;
  }
  return false;
};

export const validateCiamEmailResponse = (data) => {
  const ciamData = data?.getCiamStatusByEmail;

  if (!ciamData) {
    return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.ERROR };
  }

  switch (ciamData.status) {
    case 404:
      return { isValid: true };
    case 200:
      if (ciamData.ciamStatus === 'Active') {
        if (
          EIV_STATUS_ALLOWED_TO_REGISTER_EXISTING_EMAIL.includes(ciamData.statusStrom) &&
          EIV_STATUS_ALLOWED_TO_REGISTER_EXISTING_EMAIL.includes(ciamData.statusGas)
        ) {
          return { isValid: true };
        }
        return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.ACTIVE };
      }
      if (ciamData.ciamStatus === 'pending') {
        return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.PENDING };
      }
      if (ciamData.ciamStatus === null) {
        if (isPendingCiamRegistration(ciamData.statusStrom, ciamData.statusGas)) {
          return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.PENDING };
        }
        if (
          EIV_STATUS_ALLOWED_TO_REGISTER_EXISTING_EMAIL.includes(ciamData.statusStrom) &&
          EIV_STATUS_ALLOWED_TO_REGISTER_EXISTING_EMAIL.includes(ciamData.statusGas)
        ) {
          return { isValid: true };
        }
        return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.DUPLICATE };
      }
      return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.ERROR };
    case 409:
      return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.PENDING };
    default:
      return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.ERROR };
  }
};

export const checkCiamEmailByQuery = async (getCiamStatusByEmail, email) => {
  try {
    const { data } = await getCiamStatusByEmail({ variables: { email } });
    return validateCiamEmailResponse(data);
  } catch {
    return { isValid: false, errorType: CIAM_EMAIL_ERROR_TYPES.ERROR };
  }
};
